import { i18n } from "@lingui/core";
import { en, es, zh, ko, ru, ja, fr } from "make-plural/plurals";
import { LANGUAGE_LOCALSTORAGE_KEY } from "config/localStorage";

export const locales = {
  // zh: "Chinese",
  zh: "简体中文",
  en: "English",
  // es: "Spanish",
  // ko: "Korean",
  // ru: "Russian",
  // ja: "Japanese",
  // fr: "French",
};

export const defaultLocale = "en";

i18n.loadLocaleData({
  zh: { plurals: zh },
  en: { plurals: en },
  es: { plurals: es },
  ko: { plurals: ko },
  ru: { plurals: ru },
  ja: { plurals: ja },
  fr: { plurals: fr },
});

export async function dynamicActivate(locale) {
  const { messages } = await import(`@lingui/loader!locales/${locale}/messages.po`);
  localStorage.setItem(LANGUAGE_LOCALSTORAGE_KEY, locale);
  i18n.load(locale, messages);
  i18n.activate(locale);
}
